import { VisiblePrescriptionStatus } from "common/types/prescriptions";

import { StatusColor } from "client/common/components/content/Status";
import { DosageReminder } from "client/reminders/types";
import { getReminderByPatientItem, getReminderKey } from "client/reminders/utils";

type PrescriptionStatusDisplay = { color: StatusColor; label: string };

const prescriptionStatusDisplay: Record<VisiblePrescriptionStatus, PrescriptionStatusDisplay> = {
  [VisiblePrescriptionStatus.Active]: {
    color: "success",
    label: "Active Prescription",
  },
  [VisiblePrescriptionStatus.Declined]: {
    color: "danger",
    label: "Declined Prescription",
  },
  [VisiblePrescriptionStatus.Draft]: {
    color: "greyscale",
    label: "Draft Prescription",
  },
  [VisiblePrescriptionStatus.ImportedActive]: {
    color: "greyscale",
    label: "Imported Prescription",
  },
  [VisiblePrescriptionStatus.ImportedInactive]: {
    color: "greyscale",
    label: "Imported Prescription",
  },
  [VisiblePrescriptionStatus.ExpiringSoon]: {
    color: "warning",
    label: "Expiring Soon",
  },
  [VisiblePrescriptionStatus.Expired]: {
    color: "warning",
    label: "Expired Prescription",
  },
  [VisiblePrescriptionStatus.NoFillsRemaining]: {
    color: "warning",
    label: "No Refills Remaining",
  },
};

const unknownStatusDisplay: PrescriptionStatusDisplay = {
  color: "greyscale",
  label: "Unknown",
};

// The backend can ship a new status before the frontend knows about it, so the lookup can miss at runtime
export const getPrescriptionStatusDisplay = (
  status: VisiblePrescriptionStatus,
): PrescriptionStatusDisplay => {
  const display = prescriptionStatusDisplay[status];
  if (!display) {
    console.warn(`Missing display for prescription status ${status}`);
    return unknownStatusDisplay;
  }
  return display;
};

type GetReminderButtonLabelParams = {
  reminders: DosageReminder[];
  itemId: number;
  patientId: number;
};

export const getReminderButtonLabel = ({
  reminders,
  itemId,
  patientId,
}: GetReminderButtonLabelParams) => {
  const reminder = getReminderByPatientItem(reminders).get(getReminderKey({ patientId, itemId }));
  if (!reminder) {
    return "Set up dosage reminder";
  }
  return "Edit dosage reminder";
};
